var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    style: {
      fill: "#ffe3b0"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t@keyframes A {to{transform:rotate(45deg)}}\n\t\t@keyframes B{to{stroke-dashoffset:-98px}}\n\t\t@keyframes D{to{stroke-dashoffset:-138px}}\n\t\t#a{\n\t\t\tfill:none;\n\t\t\tstroke:#ffe3b0;\n\t\t\tstroke-width:5.5;\n\t\t\tstroke-linecap:round;\n\t\t\ttransform-origin:center;\n\t\t\tanimation: A .4s .4s both;\n\t\t}\n\t\t#b{stroke-dasharray:40 139;animation: B .4s both;}\n\t\t#d{stroke-dasharray:40 180;animation: D .4s both;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 33h40s9-.7 9-8.5c0-7.9-8-12-14.9-10.9-6.8 1.1-13.6 4.2-13.6 16.4v40",
    id: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 50h40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 67h40c12.8 0 15.4-11.7 15.4-26.9 0-15-4.8-27.2-16.7-27.2s-18.5 7-18.4 17.1l.2 40",
    id: "d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon-cross.102a7f2db0fb5d7ab5aa1fe5ebe56bb1.svg";
export { ForwardRef as ReactComponent };